import React, { useContext, useEffect, useMemo, useState } from 'react';

import {
    MaterialReactTable,
    useMaterialReactTable,
} from 'material-react-table';
import { ThemeProvider, createTheme, useTheme } from '@mui/material';




const Calendar = ({ calendarData, calendarColumns, isLoading,loader, pagination, setPagination, paginationTotalRows, mix_background_layout }) => {
    const globalTheme = useTheme();

    const tableTheme = useMemo(
        () =>
            createTheme({
                palette: {
                    mode: mix_background_layout == "dark-only" ? "dark" : "light", //let's use the same dark/light mode as the global theme
                },
            }),
        [globalTheme, mix_background_layout],
    );



    const table = useMaterialReactTable({
        columns: calendarColumns,
        data: calendarData,
        enableExpandAll: true, //hide expand all double arrow in column header
        enableExpanding: true,
        filterFromLeafRows: true, //apply filtering to all rows instead of just parent rows
        paginateExpandedRows: true, //When rows are expanded, do not count sub-rows as number of rows on the page towards pagination
        state: { isLoading: isLoading || loader, pagination: pagination },
        onPaginationChange: setPagination,
        manualPagination: true,
        rowCount: paginationTotalRows,
        // getSubRows: (row) => row.subRows,
        enablePagination: true,
        enableBottomToolbar: true,
        enableTopToolbar: false,
        enableSorting: false,
        enableColumnActions: false,
        enableColumnPinning: true,
        enableRowPinning: false,
        enableStickyHeader: true,
        initialState: {
            expanded: true,
            // columnPinning: { left: ['categories'] },
            // rowPinning:{
            //     top:['']
            // }
        },
        muiTableBodyCellProps: ({ cell, row }) => ({
            onClick: () => {
                console.log(row.original, cell.getValue(), cell.id);
            },
            sx: {
                paddingTop: "10px",
                paddingBottom: "10px",
                paddingLeft: '0px',
                paddingRight: '0px',
                "&:nth-of-type(1)": {
                    textAlign: "center"
                },
                verticalAlign: "bottom"
            },
        }),
        muiTableBodyRowProps: {
            sx: {
                "&:hover": {
                    td: {
                        backgroundColor: "transparent"
                    }
                }
            }
        },
        muiTableHeadCellProps: {
            sx: {
                // borderLeft: '1px solid rgba(81, 81, 81, .5)',
                borderRight: '1px solid rgba(81, 81, 81, .5)',
                verticalAlign: "middle",
                "& .Mui-TableHeadCell-Content": {
                    justifyContent: "center"
                }
            },
        },
        muiTablePaperProps: {
            sx: {
                boxShadow: "none",
                border: '1px solid rgba(81, 81, 81, .5)',
                overflow: "none"
            }
        },
        muiExpandAllButtonProps: ({ row, table }) => ({

            sx: {
                // width: "100px"
            }
        }),
        muiExpandButtonProps: ({ row, table }) => {
            return {
                sx: {
                    marginLeft: row.parentId ? row.parentId.length > 1 ? "60px" : "30px" : "0px"
                }
            }
        },
        muiPaginationProps: {
            rowsPerPageOptions: [10, 15, 20, 25, 30],
        },

    });


    return (
        <ThemeProvider theme={tableTheme}>
            <MaterialReactTable table={table} />
        </ThemeProvider>
    )

}


export default Calendar;
